module.exports = __webpack_public_path__ + "img/arrow-right.c88f5bb5.svg";